import React from 'react';

const AffiliatePage = () => {
  return <div>AffiliatePage</div>;
};

export default AffiliatePage;
